import { render } from "./EditVeterinarianDialog.vue?vue&type=template&id=61ee4bd8"
import script from "./EditVeterinarianDialog.vue?vue&type=script&lang=js"
export * from "./EditVeterinarianDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__